module.exports = __webpack_public_path__ + "img/nav-right-expand-search-mitsu.499fbe09.png";